// import { CloseOutlined } from '@material-ui/icons';
import { CloseOutlined } from '@mui/icons-material';
import {
  Grid,
  Alert,
  Autocomplete,
  Button,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import {
  ACTION_RIGHT_DRAWER_JSX,
  ACTION_RIGHT_DRAWER_NOT,
} from '../../../component/MainUIFrame/constants';
import {
  useMainFrameDispatch,
  useMainFrameState,
} from '../../../component/MainUIFrame/MainFrame';
import { usaStateListWithCodes } from '../../../data/fhirHumanNameData';
import { LICENSE_TYPES } from './helper-json';
import { red } from '@mui/material/colors';
import _ from 'lodash';

const label = (
  <>
    Secondary License
    <span style={{ color: red[500] }}>*</span>
  </>
);

const AddLicense = props => {
  const { licenses, setLicenses, setValue, isDEA } = props;
  const dispatch = useMainFrameDispatch();
  const { isDark } = useMainFrameState();

  const [licenseForm, setLicenseForm] = useState({
    state: '',
    licenseType: isDEA ? 'DEA' : 'None',
    number: '',
    secondary_number: '',
  });
  const [licenseFormErrors, setLicenseFormErrors] = useState({
    state: '',
    number: '',
  });
  const [usaCodes] = useState(
    usaStateListWithCodes.map(m => {
      return {
        label: m.code,
        value: m.code,
      };
    })
  );

  useEffect(() => {
    return () => handleClose;
  }, []);

  const handleClose = () => {
    dispatch({ type: ACTION_RIGHT_DRAWER_NOT });
    dispatch({ type: ACTION_RIGHT_DRAWER_JSX, payload: <></> });
  };

  const updateLicenseTypeValues = (e, value, name) => {
    setLicenseFormErrors({
      state: '',
      number: '',
    });
    let tempLicenseValues = structuredClone(licenseForm);
    if (name === 'state') {
      tempLicenseValues.licenseType = 'None';
      tempLicenseValues.state = value;
    } else if (name === 'licenseType') {
      tempLicenseValues.state = { label: '', value: '' };
      tempLicenseValues.licenseType = e?.target?.value;
    } else if (name === 'number') {
      tempLicenseValues.number = value;
    } else if (name === 'secondary_number') {
      tempLicenseValues.secondary_number = value;
    }
    setLicenseForm(structuredClone(tempLicenseValues));
  };

  const validateLicense = () => {
    let isValidated = true;
    let tempErrors = structuredClone(licenseFormErrors);
    if (!licenseForm.state?.value && licenseForm?.licenseType === 'None') {
      isValidated = false;
      tempErrors.state = 'State or License type is required';
    } else if (!licenseForm?.number) {
      isValidated = false;
      tempErrors.number = 'License number is required';
    } else if (licenses.filter(l => l?.number === licenseForm?.number).length) {
      isValidated = false;
      tempErrors.number = 'License number is already added.';
    } else if (
      licenseForm.state?.value &&
      licenses.filter(f => f.state?.value === licenseForm.state?.value).length
    ) {
      isValidated = false;
      tempErrors.number = 'State already added with another license.';
    } else if (
      licenseForm?.state?.value &&
      (licenseForm?.state?.value === 'PR' ||
        licenseForm?.state?.value === 'DC') &&
      !licenseForm.secondary_number
    ) {
      isValidated = false;
      tempErrors.number =
        'Secondary license is required for States "PR" & "DC".';
    } else {
      tempErrors.state = '';
      tempErrors.number = '';
    }
    setLicenseFormErrors(structuredClone(tempErrors));
    return isValidated;
  };

  const addLicense = () => {
    if (validateLicense()) {
      let tempLicenses = [...licenses];
      tempLicenses.push(licenseForm);
      setLicenses([...tempLicenses]);
      setValue('licenses', tempLicenses);
      setLicenseForm({
        state: '',
        licenseType: 'None',
        number: '',
        secondary_number: '',
      });
      handleClose();
    } else return false;
  };

  return (
    <>
      <Grid container style={{ marginTop: '1em' }}>
        <Grid item xs={10}>
          <Typography align="center" noWrap variant="h6">
            Add {isDEA ? 'DEA' : 'State'} License
          </Typography>
          <br />
        </Grid>
        <Grid item xs={2}>
          <IconButton onClick={handleClose}>
            <CloseOutlined />
          </IconButton>
        </Grid>
      </Grid>
      <Grid
        container
        columnSpacing={1}
        rowSpacing={1}
        style={{ padding: '0 5px' }}
      >
        <Grid item xs={12}>
          {(licenseFormErrors.state || licenseFormErrors.number) && (
            <Alert severity="error">
              {licenseFormErrors.state || licenseFormErrors.number || ''}
            </Alert>
          )}
        </Grid>
        <Grid item xs={12} hidden>
          <label
            className={`${
              isDark ? 'sub-heading2-white' : 'sub-heading2'
            } f-400`}
          >
            License Type:*
          </label>
          <Select
            fullWidth
            displayEmpty
            value={licenseForm.licenseType}
            size="small"
            name="licenseType"
            disablePortal={true}
            onChange={(e, value) => {
              updateLicenseTypeValues(e, value, 'licenseType');
            }}
          >
            {LICENSE_TYPES.map(u => {
              return (
                <MenuItem key={u?.value} value={u?.value}>
                  {u.label}
                </MenuItem>
              );
            })}
          </Select>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            display: licenseForm?.licenseType === 'DEA' ? 'none' : 'block',
          }}
        >
          <label
            className={`${
              isDark ? 'sub-heading2-white' : 'sub-heading2'
            } f-400`}
          >
            State <span style={{ color: red[500] }}>*</span>
          </label>
          <Autocomplete
            size="small"
            disablePortal={true}
            disableClearable
            options={usaCodes}
            value={licenseForm.state}
            name="state"
            onChange={(e, value) => {
              updateLicenseTypeValues(e, value, 'state');
            }}
            renderInput={params => (
              <TextField {...params} placeholder="State" />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <label
            className={`${
              isDark ? 'sub-heading2-white' : 'sub-heading2'
            } f-400`}
          >
            License <span style={{ color: red[500] }}>*</span>
          </label>
          <TextField
            size="small"
            fullWidth
            name="number"
            placeholder="License number"
            value={licenseForm.number}
            onChange={e => {
              updateLicenseTypeValues(e, e?.target?.value, 'number');
            }}
          />
        </Grid>
        {!isDEA && (
          <Grid item xs={12}>
            <label
              className={`${
                isDark ? 'sub-heading2-white' : 'sub-heading2'
              } f-400`}
            >
              {(licenseForm.state && licenseForm.state.value === 'PR') ||
              licenseForm.state.value === 'DC'
                ? label
                : 'Secondary License'}
            </label>
            <TextField
              size="small"
              fullWidth
              name="secondary_number"
              placeholder="Secondary license number"
              value={licenseForm.secondary_number}
              onChange={e => {
                updateLicenseTypeValues(
                  e,
                  e?.target?.value,
                  'secondary_number'
                );
              }}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <Button
            variant="contained"
            fullWidth
            onClick={addLicense}
            size="small"
          >
            Add License
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default AddLicense;
